import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Button, Col, Row } from "react-bootstrap";
import "react-tabs/style/react-tabs.css";
import {
  translationConstants,
  UserVerificationApprovalStatus,
} from "../../../../../constants";
import { UserActions, profileActions } from "../../../../../redux/actions";
import CertificatesAccordionView from "../Components/CertificatesAccordionView";
import CustomModal from "../../../../../shared/components/CustomModal/CustomModal";
import BecomeCertifiedPractitioner from "../../../../../container/views/becomeCertifiedPractitioner/BecomeCertifiedPractitioner";
import { PlusIcon } from "../../../../../assets/images/icon/iconsProvider";

const CertificatesTab = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const profileData = useSelector((state) => state.ProfileReducer.profileData);
  const systemUserId = useSelector(
    (state) => state.LoginReducer.UserData?.user?.id
  );
  
  const [activeTab, setActiveTab] = useState();
  const [isModalOpen, setModalOpen] = useState(false);

  const onSetShow = () => {
    setModalOpen(false);
    dispatch(UserActions.setQualificationFormState([]));
  };

  useEffect(() => {
    dispatch(profileActions.getProfileData(systemUserId));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Row className="w-100">
        <Col md={8} className="border-vr-right">
          <div className="user-profile">
            <Tabs onSelect={(index) => setActiveTab(index)}>
              <TabList>
                <Row className=" w-100">
                  <Col>
                    <Tab>{t(translationConstants.PRACTITIONER)}</Tab>
                    {(profileData?.instructorCertificates?.length &&
                      profileData?.instructorStatus !==
                        UserVerificationApprovalStatus.Disabled) > 0 ? (
                      <Tab>{t(translationConstants.INSTRUCTOR)}</Tab>
                    ) : (
                      ""
                    )}
                  </Col>
                  <Col className="d-flex justify-content-end">
                    <Button
                      className="profile-button mt-12 btn-certificate-text"
                      type="submit"
                      onClick={() => {
                        setModalOpen(true);
                      }}
                    >
                      <PlusIcon />
                      &nbsp; {t(translationConstants.ADD_QUALIFICATION)}
                    </Button>
                  </Col>
                </Row>
              </TabList>
              <TabPanel>
                <CertificatesAccordionView
                  certificates={profileData?.practionerCertificates}
                />
              </TabPanel>
              {profileData?.instructorCertificates?.length > 0 ? (
                <TabPanel>
                  <CertificatesAccordionView
                    certificates={profileData?.instructorCertificates}
                  />
                </TabPanel>
              ) : (
                ""
              )}
            </Tabs>
          </div>
        </Col>
      </Row>

      {isModalOpen && (
        <CustomModal
          size={"lg"}
          scrollable={true}
          setShow={onSetShow}
          show={isModalOpen}
        >
          <BecomeCertifiedPractitioner
            isInstructor={activeTab}
            onSetShow={onSetShow}
          />
        </CustomModal>
      )}
    </>
  );
};

export default CertificatesTab;
